<div class="container-fluid page">
  <div class="d-flex page__box p-3 mt-2">Dashboard</div>

  <br>
  <br>

  <div class="card-container">
    <div class="card">
      <!-- Your existing content here -->
      <div class="subheader"><i class="bi bi-star"></i>
        Popular Items</div>
    
      <mat-card class="example-card">
        <div>

          <div class="row mainhead">{{card.mainhead}}</div>

          <div class="row subtitle">{{card.subhead}}</div>
        </div>

        <mat-card-content>
          <p class="cardtext">
            {{card.content}}
          </p>
        </mat-card-content>
        <div class="row">
          <div class="col-4 statusclass">ACTIVE</div>
          <div class="col-4 timeclass">5 min ago</div>
          <div class="col-4 action">...</div>
        </div>
      </mat-card>
   
      <mat-card class="example-card">
        <div>
          <div class="row mainhead">{{card.mainhead}}</div>
          <div class="row subtitle">{{card.subhead}}</div>
        </div>
        <mat-card-content>
          <p class="cardtext">
            {{card.content}}
          </p>
        </mat-card-content>
        <div class="row">
          <div class="col-4 statusclass">ACTIVE</div>
          <div class="col-4 timeclass">5 min ago</div>
          <div class="col-4 action">...</div>
        </div>
      </mat-card>
    </div>
    <div class="card">
      <div class="subheader"><i class="bi bi-book"></i>
        My Items</div>
        <!-- <ng-container *ngFor="let card of myItemsArr">
          <mat-card class="example-card" (click)="loadDynamicComponent1(card)">
            <div>
              <div class="row mainhead">{{ card?.di_tech_nm }}-{{ card?.di_bus_nm }}</div>
              <div class="row subtitle">{{ main.clArr[card?.di_tcd] }}</div>
            </div>
            <mat-card-content>
              <p class="cardtext">{{ card.di_desc }}</p>
            </mat-card-content>
            <div class="row">
              <div class="col-4 statusclass">{{ card?.status_cd }}</div>
              <div class="col-4 timeclass">{{ this.main.formatTime(card?.updatedAt) }}</div>
              <div class="col-4 action">...</div>
            </div>
          </mat-card>
        </ng-container> -->
        

    </div>

    <div class="card">
      <div class="subheader"><i class="bi bi-clock"></i>
        My Inprogress Items</div>
      <mat-card class="example-card">
        <div>

          <div class="row mainhead">{{card.mainhead}}</div>

          <div class="row subtitle">{{card.subhead}}</div>
        </div>

        <mat-card-content>
          <p class="cardtext">
            {{card.content}}
          </p>
        </mat-card-content>
        <div class="row">
          <div class="col-4 statusclass">ACTIVE</div>
          <div class="col-4 timeclass">5 min ago</div>
          <div class="col-4 action">...</div>
        </div>
      </mat-card>
      <br>
      <mat-card class="example-card">
        <div>

          <div class="row mainhead">{{card.mainhead}}</div>

          <div class="row subtitle">{{card.subhead}}</div>
        </div>

        <mat-card-content>
          <p class="cardtext">
            {{card.content}}
          </p>
        </mat-card-content>
        <div class="row">
          <div class="col-4 statusclass">ACTIVE</div>
          <div class="col-4 timeclass">5 min ago</div>
          <div class="col-4 action">...</div>
        </div>
      </mat-card>
    </div>
    </div>
</div>
